import React from "react";
import "./Chat.css";

export default function Chat() {
  return (
    <section className="live-chat" aria-label="Live chat">
      <div className="chat-frame-wrapper">
        <iframe
          src="https://www5.cbox.ws/box/?boxid=962814&boxtag=jYZdAv"
          title="Tapsi Web Radio live chat"
          allow="autoplay"
          allowtransparency="true"
          loading="lazy"
        />
      </div>
    </section>
  );
}